import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Box, Loader2 } from "lucide-react";
import "@/App.css";

export default function OwnerLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    api.get("/auth/me")
      .then(() => navigate("/owner/dashboard", { replace: true }))
      .catch(() => setChecking(false));
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/owner/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return <div className="site-shell loading-screen" data-testid="owner-login-loading"><Loader2 className="spin" size={30} /></div>;
  }

  return (
    <div className="site-shell auth-page" data-testid="owner-login-page">
      <div className="noise" aria-hidden="true" />
      <div className="auth-card">
        <span className="brand" style={{ justifyContent: "center" }}><span className="brand-mark"><Box size={18} strokeWidth={2.5} /></span><span>Biswas<span className="cyan">3D</span></span></span>
        <h1>Owner studio</h1>
        <p>The private area for Biswas3D — manage gallery photos and review customer enquiries. Sign in with the authorised Google account.</p>
        <button className="button button-primary" data-testid="owner-login-google-button" onClick={login}>Continue with Google</button>
        <Link className="auth-back" data-testid="owner-login-back-link" to="/">&larr; Back to the website</Link>
      </div>
    </div>
  );
}
